/** FA catalog — پیگیری‌ها / CRM کلینیک (ZOY-712): فهرست کار، برگهٔ پرونده، افزودن به پیگیری‌ها. */
export const crmFa: Record<string, string> = {
  'nav.followups': 'پیگیری‌ها',
  'cal.followups': 'پیگیری‌ها',

  /* ── فهرست کار ───────────────────────────────────────────────────────── */
  'crm.title': 'پیگیری‌ها',
  'crm.sub': 'کسانی که باید تماس گرفت، نوبت داد، ثبت‌نام کرد و متصل کرد — هر کدام یک خط.',
  'crm.new': 'پیگیری جدید',
  'crm.tab.open': 'باز',
  'crm.tab.closed': 'بسته',
  'crm.who.mine': 'مال من',
  'crm.who.all': 'همه',
  'crm.due.any': 'هر تاریخی',
  'crm.due.overdue': 'عقب‌افتاده',
  'crm.due.today': 'امروز',
  'crm.due.week': '۷ روز آینده',
  'crm.due.none': 'بدون تاریخ',
  'crm.f.linked': 'مراجع',
  'crm.f.linked.any': 'همه',
  'crm.f.linked.none': 'هنوز مراجعی نیست',
  'crm.f.linked.guest': 'مهمان',
  'crm.f.linked.registered': 'ثبت‌شده',
  'crm.f.req': 'درخواست خانواده',
  'crm.f.req.any': 'همه',
  'crm.f.req.yes': 'درخواست دارد',
  'crm.f.req.no': 'بدون درخواست',
  'crm.searchPh': 'جستجوی نام یا تلفن',
  'crm.col.who': 'چه کسی',
  'crm.col.next': 'قدم بعدی',
  'crm.col.note': 'آخرین یادداشت',
  'crm.col.patient': 'مراجع',
  'crm.col.visit': 'ویزیت',
  'crm.col.request': 'درخواست خانواده',
  'crm.emptyTitle': 'چیزی این‌جا نیست',
  'crm.emptyBody': 'هیچ پیگیری‌ای با این فیلترها مطابقت ندارد.',
  'crm.emptyOpenTitle': 'پیگیری باز نیست',
  'crm.emptyOpenBody':
    'درخواست‌های خانوادگی که اضافه می‌کنید، و تماس‌هایی که ثبت می‌کنید، این‌جا ظاهر می‌شوند.',
  'crm.unassigned': 'بدون مسئول',
  'crm.noNextAction': 'بدون قدم بعدی',
  'crm.noDate': 'بدون تاریخ',
  'crm.dueTone.overdue': 'عقب‌افتاده',
  'crm.dueTone.today': 'امروز',
  'crm.noNote': 'هنوز یادداشتی نیست',
  'crm.noteBy': '{name} · {when}',
  'crm.noPatient': 'هنوز مراجع نیست',
  'crm.linked.guest': 'مهمان',
  'crm.linked.registered': 'ثبت‌شده · پرونده {n}',
  'crm.linked.registeredNoFile': 'ثبت‌شده',
  'crm.linked.merged': 'ادغام شده در پرونده دیگر',
  'crm.connected': 'متصل',
  'crm.visit.next': 'بعدی {when}',
  'crm.visit.last': 'آخرین {when} · {status}',
  'crm.visit.none': '—',
  'crm.req.badge': 'درخواست · {status}',
  'crm.req.status.pending': 'در انتظار',
  'crm.req.status.expired': 'منقضی شده',
  'crm.req.status.withdrawn': 'پس‌گرفته‌شده',
  'crm.req.status.declined': 'رد شده',
  'crm.req.status.accepted': 'پذیرفته‌شده',
  'crm.req.status.cancelled': 'لغو شده',
  'crm.req.status.superseded': 'جایگزین شده',
  'crm.closedAs': 'بسته · {reason}',
  'crm.reason.converted': 'بیمار شد',
  'crm.reason.connected': 'خانواده متصل شد',
  'crm.reason.not_interested': 'علاقه‌مند نبود',
  'crm.reason.unreachable': 'در دسترس نبود',
  'crm.reason.duplicate': 'تکراری',
  'crm.reason.other': 'سایر',
  'crm.source.family_request': 'درخواست خانواده',
  'crm.source.phone_call': 'تماس تلفنی',
  'crm.source.walk_in': 'مراجعه حضوری',
  'crm.source.referral': 'معرفی',
  'crm.source.other': 'سایر',

  /* ── پیگیری جدید ─────────────────────────────────────────────────────── */
  'crm.newTitle': 'پیگیری جدید',
  'crm.newSub': 'نام و شماره کافی است — بقیه پیش‌فرض‌های معقول دارند.',
  'crm.name': 'نام',
  'crm.nameHelp': 'هر کسی که تماس می‌گیرید — نام یکی از والدین هم خوب است.',
  'crm.phone': 'تلفن',
  'crm.phoneHelp': 'شماره‌ای که باید دوباره تماس گرفت.',
  'crm.source': 'چطور با ما تماس گرفت',
  'crm.due': 'پیگیری برای',
  'crm.assignee': 'واگذار شده به',
  'crm.more': 'بیشتر',
  'crm.less': 'کمتر',
  'crm.firstNote': 'اولین یادداشت',
  'crm.nextActionText': 'قدم بعدی چیست',
  'crm.nextActionPh': 'مثلا درباره گفتاردرمانی دوباره تماس بگیر',
  'crm.create': 'ایجاد پیگیری',
  'crm.created': 'پیگیری ساخته شد.',
  'crm.phoneTooShort': 'این هنوز شبیه شماره تلفن نیست — دست‌کم ۵ رقم وارد کنید.',

  /* ── نامزدها ─────────────────────────────────────────────────────────── */
  'crm.cand.title': 'این شماره از قبل شناخته‌شده است',
  'crm.cand.body':
    'پرونده‌ای را که این به آن تعلق دارد انتخاب کنید، یا یکی جدید بسازید. تا انتخاب نکنید چیزی وصل نمی‌شود.',
  'crm.cand.records': 'پیگیری‌هایی با این شماره',
  'crm.cand.patients': 'بیمارانی با این شماره',
  'crm.cand.match.phone': 'همین شماره',
  'crm.cand.match.account': 'همین حساب خانواده',
  'crm.cand.attach': 'وصل به این',
  'crm.cand.open': 'باز کردن',
  'crm.cand.forPatient': 'پیگیری جدید برای این بیمار',
  'crm.cand.new': 'ایجاد پیگیری جدید',
  'crm.cand.closedNote': 'بسته — دوباره باز می‌شود',
  'crm.cand.state.open': 'باز',
  'crm.cand.state.closed': 'بسته',

  /* ── صندوق درخواست‌ها ───────────────────────────────────────────────── */
  'crm.req.add': 'افزودن به پیگیری‌ها',
  'crm.req.in': 'در پیگیری‌ها',
  'crm.req.added': 'به پیگیری‌ها اضافه شد.',
  'crm.req.attached': 'به پیگیری موجود وصل شد.',
  'crm.req.reopened': 'پیگیری بسته بود — دوباره باز است.',

  /* ── برگهٔ پرونده ───────────────────────────────────────────────────── */
  'crm.sheet.title': 'پیگیری',
  'crm.sheet.close': 'بستن',
  'crm.sheet.status.open': 'باز',
  'crm.sheet.status.closed': 'بسته',
  'crm.sheet.since': 'از {when}',
  'crm.sheet.assignMe': 'به من واگذار کن',
  'crm.sheet.nextAction': 'قدم بعدی',
  'crm.sheet.dueDate': 'موعد',
  'crm.sheet.preset.today': 'امروز',
  'crm.sheet.preset.tomorrow': 'فردا',
  'crm.sheet.preset.in3': '۳ روز دیگر',
  'crm.sheet.preset.nextWeek': 'هفته بعد',
  'crm.sheet.preset.clear': 'بدون تاریخ',
  'crm.sheet.saved': 'ذخیره شد',
  'crm.sheet.quickNote': 'افزودن یادداشت',
  'crm.sheet.quickNotePh': 'چه گفته شد، چه توافق شد… (Enter ذخیره می‌کند، Shift+Enter خط جدید)',
  'crm.sheet.noteSave': 'ذخیره یادداشت',
  'crm.sheet.noteEdit': 'ویرایش',
  'crm.sheet.noteRemove': 'برداشتن',
  'crm.sheet.noteRemoveTitle': 'این یادداشت حذف شود؟',
  'crm.sheet.noteRemoveBody': 'از پرونده خارج می‌شود؛ متن در ردپای حسابرسی می‌ماند.',
  'crm.sheet.edited': 'ویرایش‌شده',
  'crm.sheet.timeline': 'یادداشت‌ها و تاریخچه',
  'crm.sheet.timelineEmpty': 'هنوز چیزی نیست — اولین یادداشت را اضافه کنید.',
  'crm.sheet.patient': 'مراجع',
  'crm.sheet.openPatient': 'باز کردن پرونده',
  'crm.sheet.createGuest': 'ایجاد مهمان',
  'crm.sheet.linkExisting': 'اتصال به بیمار موجود',
  'crm.sheet.relink': 'تغییر مراجع',
  'crm.sheet.bookVisit': 'ثبت نوبت',
  'crm.sheet.connect': 'اتصال خانواده',
  'crm.sheet.connectHint':
    'از تب «خانواده»ی پروندهٔ بیمار متصل کنید — شمارهٔ خانواده باید روی پرونده باشد (موبایل تماس یا شمارهٔ همراه).',
  'crm.sheet.attachRequest': 'وصل کردن درخواست در انتظار از {name}',
  'crm.sheet.requests': 'درخواست‌های خانواده',
  'crm.sheet.reqLine': '{name} · {mobile} · {status}',
  'crm.sheet.reqExpires': 'منقضی می‌شود {when}',
  'crm.sheet.message': 'پیام آن‌ها: {text}',
  'crm.sheet.closeCta': 'بستن پیگیری',
  'crm.sheet.reopen': 'بازکردن دوباره',
  'crm.sheet.closeTitle': 'بستن این پیگیری',
  'crm.sheet.closeBody':
    'از فهرست باز خارج می‌شود و تاریخچه‌اش را نگه می‌دارد. هر وقت خواستید دوباره بازش کنید.',
  'crm.sheet.closeReason': 'دلیل',
  'crm.sheet.closeNote': 'یادداشت (اختیاری)',
  'crm.sheet.closed': 'بسته شد.',
  'crm.sheet.reopened': 'بازگشایی شد.',
  'crm.sheet.promptConnected': 'خانواده وصل شد. این پیگیری به‌عنوان «خانواده وصل شد» بسته شود؟',
  'crm.sheet.promptRegistered': 'مراجع ثبت شد. این پیگیری به‌عنوان «مراجع شد» بسته شود؟',
  'crm.sheet.promptClose': 'بسته شود',
  'crm.sheet.stale':
    'یک نفر دیگر در این فاصله این پیگیری را عوض کرد — دوباره بارگذاری شد. تغییرتان را دوباره اعمال کنید.',
  'crm.sheet.fullDetails': 'جزئیات کامل',

  /* ── ایجاد مهمان از پیگیری ──────────────────────────────────────────── */
  'crm.guest.title': 'ایجاد مهمان',
  'crm.guest.sub':
    'نام خودِ کودک — پیگیری معمولاً به نام پدر یا مادر است. مهمان نوبت می‌گیرد؛ ثبت‌نام بعداً انجام می‌شود.',
  'crm.guest.first': 'نام کودک',
  'crm.guest.last': 'نام خانوادگی کودک',
  'crm.guest.contact': 'موبایل تماس',
  'crm.guest.contactHelp': 'از پیگیری پیش‌پر می‌شود؛ اگر شماره پرونده فرق دارد عوضش کنید.',
  'crm.guest.caregiverTitle': 'همراه روی پرونده',
  'crm.guest.caregiverHelp':
    'از درخواست خانواده پیش‌پر می‌شود. برای اضافه کردنش نسبت را انتخاب کنید؛ خالی بگذارید تا رد شود.',
  'crm.guest.cgName': 'نام همراه',
  'crm.guest.cgMobile': 'موبایل همراه',
  'crm.guest.cgRelationship': 'نسبت',
  'crm.guest.cgSkip': '— اکنون نه —',
  'crm.guest.create': 'ایجاد مهمان',
  'crm.guest.created': 'مهمان ساخته و وصل شد.',
  'crm.guest.dupTitle': 'بیمار مشابهی از قبل هست',
  'crm.guest.dupBody': 'به‌جای ساختن دومی، مراجع موجود را وصل کنید.',

  /* ── اتصال به بیمار موجود ──────────────────────────────────────────── */
  'crm.link.title': 'اتصال به بیمار موجود',
  'crm.link.body':
    'مراجعی را انتخاب کنید که این پیگیری درباره اوست. مهمان‌ها و مراجعان ثبت‌شده هر دو واجد شرایط اند.',
  'crm.link.byPhone': 'دارای این شماره',
  'crm.link.byPhoneNone': 'هیچ مراجعی این شماره را ندارد.',
  'crm.link.search': 'جستجوی مراجع',
  'crm.link.searchHelp': 'نام یا شماره پرونده.',
  'crm.link.searchNone': 'هیچ مراجعی مطابقت ندارد.',
  'crm.link.pick': 'انتخاب',
  'crm.link.picked': 'انتخاب شد',
  'crm.link.confirm': 'وصل کردن این مراجع',
  'crm.link.linked': 'مراجع وصل شد.',
  'crm.link.needsChoice': 'اول یک مراجع انتخاب کنید.',
  'crm.link.reason': 'چرا (اختیاری)',

  /* ── کارت پروندهٔ بیمار ─────────────────────────────────────────────── */
  'crm.card.title': 'پیگیری',
  'crm.card.open': 'باز کردن در پیگیری‌ها',

  /* ── میز نوبت‌دهی ──────────────────────────────────────────────────── */
  'crm.res.new': 'پیگیری جدید',

  /* ── خطاها ───────────────────────────────────────────────────────────── */
  'crm.err.gone': 'آن پیگیری دیگر وجود ندارد — فهرست به‌روز شد.',
  'crm.err.noteGone': 'آن یادداشت از قبل حذف‌شده — پرونده به‌روز شد.',
  'crm.err.closed': 'این پیگیری بسته است — اول بازش کنید.',
  'crm.err.notClosed': 'این پیگیری بسته نیست.',
  'crm.err.alreadyLinked': 'مراجعی از قبل به این پیگیری وصل است — پرونده به‌روز شد.',
  'crm.err.stale':
    'یک نفر دیگر در این فاصله این پیگیری را عوض کرد — دوباره بارگذاری شد؛ تغییرتان را دوباره اعمال کنید.',
  'crm.err.notRequest': 'آن سطر یک درخواست خانواده نیست.',
  'crm.err.attachedElsewhere': 'آن درخواست از قبل مال پیگیری دیگری است.',
  'crm.err.phone':
    'این شماره به‌عنوان شماره تلفن خوانده نشد — با کد منطقه واردش کنید، مثلا ۰۲۱… یا ۰۹۱۲….',
  'crm.err.patientGone': 'آن مراجع دیگر وجود ندارد.',
  'crm.err.patientMerged': 'آن مراجع در پرونده دیگری ادغام شد — پرونده باقی‌مانده را وصل کنید.',
  'crm.err.requestGone': 'آن درخواست خانواده دیگر وجود ندارد — صندوق ورودی به‌روز شد.',
  'crm.err.refused': 'سامانه کلینیک این تغییر را نپذیرفت — هیچ‌چیز از آنچه نوشتید از بین نرفت.',

  /* ── رویدادهای تاریخچه ─────────────────────────────────────────────── */
  'crm.ev.record_created': 'پیگیری ساخته شد',
  'crm.ev.source_family_request': 'درخواست خانواده اضافه شد',
  'crm.ev.source_phone_call': 'تماس تلفنی ثبت شد',
  'crm.ev.source_walk_in': 'مراجعه حضوری ثبت شد',
  'crm.ev.source_referral': 'ارجاع ثبت شد',
  'crm.ev.source_other': 'منبع اضافه شد',
  'crm.ev.request_pending': 'درخواست در انتظار',
  'crm.ev.request_expired': 'درخواست منقضی شد',
  'crm.ev.request_withdrawn': 'درخواست توسط خانواده پس‌گرفته شد',
  'crm.ev.request_declined': 'درخواست رد شد',
  'crm.ev.request_accepted': 'درخواست پذیرفته شد',
  'crm.ev.request_cancelled': 'درخواست لغو شد',
  'crm.ev.patient_created': 'مهمان ساخته شد',
  'crm.ev.patient_registered': 'مراجع ثبت شد',
  'crm.ev.booking_booked': 'نوبت ثبت شد',
  'crm.ev.booking_cancelled': 'ویزیت لغو شد',
  'crm.ev.booking_no_show': 'ویزیت — غیبت',
  'crm.ev.connected': 'خانواده متصل شد',
  'crm.ev.closed': 'بسته شد',
  'crm.ev.other': 'به‌روزرسانی',

  /* ── واگذاری ─────────────────────────────────────────────────────────── */
  'crm.assign.none': 'بدون مسئول',
  'crm.assign.me': 'من',
};
